module.exports = __webpack_public_path__ + "static/aws_developer-a6c61bd263aa5a4407fc60e01c39cd41.png";